import Card from "./Card";

const Grid = (props) => {
  const { openMenu, setContentSlideMenu, ConfigVar } = props;

  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {Object.keys(ConfigVar.apps).map((item, i) => {
        const app = ConfigVar.apps[item];
        const cardProps = {
          title: app.title,
          text: app.description,
          link: app.link,
          accent: ConfigVar.accent,
          darkText: Boolean(ConfigVar.colorText),
          image: app.image,
          index: i,
        };
        if (typeof app.link !== 'string') {
          cardProps.openMenu = openMenu;
          cardProps.contentMenu = () => setContentSlideMenu(app.link);
        }
        return <Card key={item} {...cardProps} />;
      })}
    </div>
  );
};

export default Grid;
